import React from 'react';

// Extracted from LessonWorkspace.js (Phase 3 of the platform-health plan:
// split the file mechanically, without changing behavior). The
// bottom-right floating buttons (dictionary, chat, reactions) plus the
// reaction emoji picker and its outside-click closer.
const REACTIONS = [
  { e: '😠', k: 'angry' },
  { e: '😂', k: 'laugh' },
  { e: '👏', k: 'clap' },
  { e: '👍', k: 'up' },
  { e: '💡', k: 'idea' },
];

export default function ReactionsFab({
  studentId,
  reactionsMenuOpen,
  onOpenDictionary,
  onOpenChat,
  onToggleReactionsMenu,
  onCloseReactionsMenu,
  onSendReaction,
}) {
  return (
    <>
      <div style={{ position: 'fixed', right: 20, bottom: 20, zIndex: 2147483646 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'center', position: 'relative' }}>
          {/* Кнопка словарика */}
          <button
            type="button"
            data-tour="lesson-dictionary"
            onClick={onOpenDictionary}
            title="Dictionary"
            style={{
              width: 50,
              height: 50,
              borderRadius: '50%',
              border: 'none',
              background: '#fff',
              boxShadow: '0 8px 18px rgba(0,0,0,0.2)',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 24,
              transition: 'transform 0.2s',
              color: '#333',
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5m6.5-11a.5.5 0 0 0-1 0V6H6a.5.5 0 0 0 0 1h1.5v1.5a.5.5 0 0 0 1 0V7H10a.5.5 0 0 0 0-1H8.5z"/>
            </svg>
          </button>

          {/* Кнопка чата */}
          {studentId && (
            <button
              type="button"
              data-tour="lesson-chat"
              onClick={onOpenChat}
              title="Chat"
              style={{
                width: 50,
                height: 50,
                borderRadius: '50%',
                border: 'none',
                background: '#fff',
                boxShadow: '0 8px 18px rgba(0,0,0,0.2)',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 24,
                transition: 'transform 0.2s',
                color: '#333',
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.5a1 1 0 0 0-.8.4l-1.9 2.533a1 1 0 0 1-1.6 0L5.3 12.4a1 1 0 0 0-.8-.4H2a2 2 0 0 1-2-2zm5 4a1 1 0 1 0-2 0 1 1 0 0 0 2 0m4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
              </svg>
            </button>
          )}

          {/* Основная кнопка */}
          <button
            type="button"
            data-tour="lesson-reactions"
            onClick={onToggleReactionsMenu}
            style={{
              width: 50,
              height: 50,
              borderRadius: '50%',
              border: 'none',
              background: '#fff',
              boxShadow: '0 8px 18px rgba(0,0,0,0.2)',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 24,
              transition: 'transform 0.2s',
              color: '#ff4757',
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"/>
            </svg>
          </button>

          {/* Выпадающее меню с остальными реакциями */}
          {reactionsMenuOpen && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
                marginBottom: 8,
                animation: 'fadeInUp 0.2s ease-out',
              }}
            >
              {REACTIONS.map((it) => (
                <button
                  key={it.k}
                  type="button"
                  title={it.k}
                  onClick={() => onSendReaction(it.e)}
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    border: 'none',
                    background: '#fff',
                    boxShadow: '0 8px 18px rgba(0,0,0,0.2)',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 20,
                    transition: 'transform 0.15s',
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.15)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                >
                  <span>{it.e}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Закрытие меню при клике вне его */}
      {reactionsMenuOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 2147483645,
          }}
          onClick={onCloseReactionsMenu}
        />
      )}
    </>
  );
}
